import React from 'react'
import "../assets/css/style.css"; // Import main styles
import "../assets/css/style2.css"; // Import responsive styles
import "../assets/css/menu.css"; // Import responsive styles
import "../assets/css/responsive.css"; // Import responsive styles
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";

// image import
import logo from "../assets/img/logo1.png";
import whatsapp from "../assets/img/w.png";
import offer1 from "../assets/img/offer1.jpg";
import services from "../assets/img/services.png";
import { useEffect } from "react";

export default function Nave() {

     const location = useLocation();

        useEffect(() => {
            const timer = setTimeout(() => {
            const modalEl = document.getElementById('myModal');
            if (modalEl) {
                const modal = new window.bootstrap.Modal(modalEl);
                modal.show();
            }
            }, 7000); // 7 second

            return () => clearTimeout(timer);
  }, [location.pathname]); // route change hone pe re-run

     useEffect(() => {
    const toggleBtn = document.getElementById("navbar-toggle");
    const navList = document.querySelector(".nav-list");

    const handleToggle = (e) => {
      e.preventDefault();
      navList.classList.toggle("open");
    };

    toggleBtn.addEventListener("click", handleToggle);
    return () => toggleBtn.removeEventListener("click", handleToggle);
  }, []);
  
    useEffect(() => {
    const button = document.getElementById("button");

    // Show / hide on scroll
    const handleScroll = () => {
      if (window.scrollY > 300) {
        button.classList.add("show");
      } else {
        button.classList.remove("show");
      }
    };

    // Smooth scroll to top on click
    const handleClick = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    window.addEventListener("scroll", handleScroll);
    button.addEventListener("click", handleClick);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      button.removeEventListener("click", handleClick);
    };
  }, []);
  return (
    <>
       
    <div className="calltoaction">
        <a href="https://wa.me/+919350273640?text=Hello" target="_blank" rel="noopener noreferrer">
            <img src={whatsapp} alt="whatsapp" />
        </a>
        </div>
        <link id="button" className="show"></link>
        <header>
            <div className="navigation">
                <div className="container">
                    <div className="brand">
                        <a href="https://www.stockcod.com">
                            <img src={logo} alt="logo" />
                        </a>
                    </div>
                    <nav>
                        <div className="nav-mobile">
                            <Link id="navbar-toggle" to="#"><span></span></Link>
                        </div>
                        <ul className="nav-list">
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to="/about-us">About</Link>
                            </li>
                            <li className="dropdownset">
                                <Link to="/service">Services</Link>
                                <ul className="navbar-dropdown">
                                    <li>
                                        <Link to="/website-development">Website Development</Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <Link to="/contact-us">Contact Us</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
        {/* The Modal */}
        <div className="modal popupmodel" id="myModal">
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* <!-- Modal Header  */}
                    <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="popupimgs">
                            <Link to="#" data-bs-toggle="modal" data-bs-target="#en">
                                <img src={offer1} alt="offer" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>


         {/* modal2  */}
        <div className="modal popupmodel en" id="en">
        <div className="modal-dialog">
            <div className="modal-content">
                {/* Modal Header  */}
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                {/* Modal body */}
                <div className="modal-body">
                    <div className="enquiryform">
                        <div className="contactform">
                            <form action="form2.php" method="POST" id="emailForm">
                                <h2>Get In Touch</h2>
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3 mt-3">
                                            <i className="fa fa-user" aria-hidden="true"></i> <input type="text" className="form-control" id="name" placeholder="Enter Name" name="name" required />
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3 mt-3">
                                            <i className="fa fa-envelope" aria-hidden="true"></i> <input type="email" className="form-control" id="email" placeholder="Enter Email Id" name="email" required />
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3 mt-3">
                                            <i className="fa fa-phone" aria-hidden="true"></i>  <input type="number" className="form-control" id="contact" placeholder="Enter Phone Number" name="contact" required />
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <div className="mb-3 mt-3">
                                            <img src={services} className="sericont" alt="services" />
                                            <select className="form-control"defaultValue="option1" name="service" id="service" required>
                                                <option value="option1" disabled>Select Services</option>
                                                <option value="Web Site Development">Web Site Development</option>
                                                <option value="Search Engine Optimization">Search Engine Optimization</option>
                                                <option value="Graphic Design">Graphic Design</option>
                                                <option value="Video Editing">Video Editing</option>
                                                <option value="Mothion Graphic">Mothion Graphic</option>
                                                <option value="Social Media Marketing">Social Media Marketing</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-12">
                                        <div className="mb-3 mt-3">
                                            <i className="fa fa-comments" aria-hidden="true"></i> <textarea placeholder="Message" id="message" name="message" className="form-control" required></textarea>
                                        </div>
                                    </div>
                                </div>
                            <button type="submit" className="btn btn-primary" id="SubmitBtn" name="SubmitBtn">Send Message</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>

    </>
  )
}
